<template>
  <div class="row">
    <div :class="{
      [ $ALERT_COL ]: true,
      'mx-auto': setup
    }">
      <Alert class="alert-attention" icon="IconStar" title="Shopify employee's store">
        <p class="mb-0">Superchargify is <span class="em-line">absolutely free</span> for Shopify employees!</p>
      </Alert>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    setup: Boolean
  }
}
</script>
